module.exports = __webpack_public_path__ + "static/media/LogoFull.0f8f0c0e.svg";